module.exports = __webpack_public_path__ + "static/media/nexio.6e73b99f.png";